import React from 'react';
import './FormStyles.css';

export default function TextInput({
  label,
  name,
  type = 'text',
  value,
  onChange,
  error,
  required = false,
  disabled = false,
  placeholder = '',
  maxLength = null,
  className = '',
}) {
  return (
    <div className={`form-group ${className}`}>
      {label && (
        <label htmlFor={name} className="form-label">
          {label}
          {required && <span className="required">*</span>}
        </label>
      )}
      <input
        id={name}
        type={type}
        name={name}
        value={value || ''}
        onChange={onChange}
        disabled={disabled}
        placeholder={placeholder}
        maxLength={maxLength}
        className={`form-input ${error ? 'error' : ''}`}
      />
      {error && <div className="form-error">{error}</div>}
    </div>
  );
}
